package com.downdogapp.client.controllers

import com.downdogapp.client.Orientation.EITHER
import com.downdogapp.client.View
import com.downdogapp.client.ViewController
import com.downdogapp.client.singleton.AlertAction
import com.downdogapp.client.singleton.App
import com.downdogapp.client.views.AlertView

class AlertViewController(val title: String? = null,
                          val message: String,
                          val negativeButton: AlertAction? = null,
                          val positiveButton: AlertAction) : ViewController(orientation = EITHER) {

  override val view: View = AlertView(this)

  init {
    logEvent(
      "alert.shown",
      mapOf(
        "title" to title,
        "message" to message,
        "positive" to positiveButton.title,
        "negative" to (negativeButton?.title ?: "null")
      )
    )
  }

  fun onNegativeButtonClicked() {
    App.popViewController {
      negativeButton!!.callback()
    }
  }

  fun onPositiveButtonClicked() {
    App.popViewController {
      positiveButton.callback()
    }
  }

  override fun onBackClicked() {
    if (negativeButton == null) {
      onPositiveButtonClicked()
    } else {
      onNegativeButtonClicked()
    }
  }
}
